// @ts-nocheck
// ⚠️ Do not edit ⚠️
// This file is automagically generated
// See codegen.yml under `graphql-codegen`
export type JSONType = null | string | boolean | number | JSONType[] | { [key: string]: JSONType }


      export type PossibleTypesResultData = {
  "possibleTypes": {
    "AddToCartPrompt": [
      "AddToCartPromptError",
      "AddToCartPromptGiftcard",
      "AddToCartPromptPersonalization",
      "AddToCartPromptSelectVariant",
      "AddToCartPromptSuccess"
    ],
    "AddToCartPromptSuccessTactic": [
      "TacticAddAndSave",
      "TacticBuildYourDiscount",
      "TacticMatchingVariant",
      "TacticRelativeDiscount"
    ],
    "AnchorInjectionType": [
      "InjectionTypeAnchor",
      "InjectionTypeGrid"
    ],
    "Attribute": [
      "BaseAttribute",
      "MoneyAttribute",
      "ProductAttribute",
      "ProductsWithQuantityAttribute"
    ],
    "BlockType": [
      "Block",
      "AccordionListBlock",
      "ActiveCampaignBlock",
      "GalleryBlock",
      "InfoPanelBlock",
      "PageGridBlock",
      "PageSliderBlock",
      "ProductGridSelectorBlock",
      "ProductListBlock",
      "ProductSliderBlock",
      "USPBlock"
    ],
    "BlockTypeWithGlobal": [
      "Block",
      "AccordionListBlock",
      "ActiveCampaignBlock",
      "GalleryBlock",
      "GlobalBlock",
      "InfoPanelBlock",
      "PageGridBlock",
      "PageSliderBlock",
      "ProductGridSelectorBlock",
      "ProductListBlock",
      "ProductSliderBlock",
      "USPBlock"
    ],
    "CartLineItemType": [
      "CartLineItemTypeBundle",
      "CartLineItemTypeFreeProduct",
      "CartLineItemTypeGeneric",
      "CartLineItemTypeGiftcard",
      "CartLineItemTypeUpsellBundle",
      "CartLineItemTypeUpsellGeneric",
      "CartLineItemTypeUpsellPersonalization"
    ],
    "CartMilestoneStepOption": [
      "CartMilestoneStepOptionDiscountCode",
      "CartMilestoneStepOptionProducts"
    ],
    "Element": [
      "ElementButton",
      "ElementChip",
      "ElementLabel",
      "ElementTypography",
      "ElementTypographyRTE"
    ],
    "Field": [
      "ProductField",
      "JSONField",
      "LinkField",
      "MultipleLinkField",
      "ReferenceField",
      "RTEField",
      "ObjectField",
      "NavigationField"
    ],
    "FinalizeCartPrompt": [
      "FinalizeCartPromptError"
    ],
    "GuidedFilter": [
      "GuidedFilterAttributeEnum",
      "GuidedFilterLinkResource"
    ],
    "IAttribute": [
      "BaseAttribute",
      "MoneyAttribute",
      "ProductAttribute",
      "ProductsWithQuantityAttribute"
    ],
    "IBlock": [
      "AccordionListBlock",
      "ActiveCampaignBlock",
      "Block",
      "GalleryBlock",
      "GlobalBlock",
      "InfoPanelBlock",
      "PageGridBlock",
      "PageSliderBlock",
      "ProductGridSelectorBlock",
      "ProductListBlock",
      "ProductSliderBlock",
      "USPBlock"
    ],
    "IField": [
      "JSONField",
      "LinkField",
      "MultipleLinkField",
      "NavigationField",
      "ObjectField",
      "ProductField",
      "RTEField",
      "ReferenceField"
    ],
    "IGuidedFilter": [
      "GuidedFilterAttributeEnum",
      "GuidedFilterLinkResource"
    ],
    "IGuidedFilterItem": [
      "GuidedFilterAttributeEnumItem",
      "GuidedFilterLinkResourceItem"
    ],
    "IWithAssets": [
      "LineItem",
      "Product"
    ],
    "IWithBlocks": [
      "BlockInjection",
      "CommunicationTemplate",
      "CommunicationTemplateLayoutFooter",
      "CommunicationTemplateLayoutHeader",
      "Email",
      "EmailLayoutFooter",
      "EmailLayoutHeader",
      "InjectionPlacementBlocks",
      "InjectionTypeAnchor",
      "InjectionTypeBlockData",
      "InjectionTypeGrid",
      "NavigationItem",
      "Page",
      "TacticBlocks"
    ],
    "IWithBrand": [
      "Page",
      "Product"
    ],
    "IWithCartLineItemLink": [
      "CartLineItemTypeBundle",
      "CartLineItemTypeFreeProduct",
      "CartLineItemTypeGeneric",
      "CartLineItemTypeGiftcard",
      "CartLineItemTypeUpsellBundle",
      "CartLineItemTypeUpsellGeneric",
      "CartLineItemTypeUpsellPersonalization"
    ],
    "IWithCategories": [
      "Product"
    ],
    "IWithElements": [
      "TileResource"
    ],
    "IWithFields": [
      "AccordionItem",
      "AccordionListBlock",
      "Bar",
      "Block",
      "CommunicationTemplate",
      "Email",
      "GalleryBlock",
      "GalleryBlockSlide",
      "GlobalBlock",
      "ImageResource",
      "Page",
      "ProductGridSelectorBlock",
      "ProductListBlock"
    ],
    "IWithFilter": [
      "ProductListBlock",
      "ProductSliderBlock"
    ],
    "IWithImages": [
      "GalleryBlockSlide"
    ],
    "IWithIndex": [
      "AddToCartPromptError",
      "AddToCartPromptGiftcard",
      "AddToCartPromptPersonalization",
      "AddToCartPromptSelectVariant",
      "RemoveFromCartPromptError",
      "SetQuantityInCartPromptError",
      "SetVariantInCartPromptError"
    ],
    "IWithMoney": [
      "Money",
      "Price",
      "PriceDiscount"
    ],
    "IWithProduct": [
      "AddToCartPromptPersonalization",
      "AddToCartPromptSelectVariant",
      "CartLineItem",
      "LineItem",
      "OrderReviewProductReview",
      "ProductField",
      "ProductWithQuantity",
      "ReturnOptionLineItem",
      "TacticGenericOffer",
      "TacticMatchingVariant",
      "TacticUpgradeWithItem",
      "Upsell"
    ],
    "IWithProducts": [
      "AddToCartPromptPersonalization",
      "AddToCartPromptSelectVariant",
      "CartMilestoneStepOptionProducts",
      "ComplementaryRecommendations",
      "HouseBrand",
      "LinkedProduct",
      "ProductAttribute",
      "Recommendation",
      "Recommendations",
      "TacticBuildYourDiscount",
      "TacticComplementaryProducts",
      "TacticLinkedProductsGroup",
      "TacticRelatedProducts",
      "TacticRelativeDiscount",
      "TacticSimilarProducts",
      "UserRecommendations"
    ],
    "IWithRecommendations": [
      "AddToCartPromptSuccess",
      "Cart",
      "TacticOthersBought",
      "TacticOthersBoughtGrid",
      "TacticRecommendedForYou"
    ],
    "IWithReferences": [
      "CaptionOptions",
      "Link",
      "LinkField",
      "PageGridBlock",
      "PageSliderBlock",
      "ProductListBlock",
      "ProductSliderBlock",
      "ProductSpecificationItemReference",
      "ReferenceField",
      "TileResource"
    ],
    "IWithReferencesWithKey": [
      "RTEField"
    ],
    "Injection": [
      "AnchorInjection",
      "BlockInjection"
    ],
    "InjectionPlacement": [
      "InjectionPlacementBlocks",
      "InjectionPlacementBlockTypes",
      "InjectionPlacementGlobal",
      "InjectionPlacementPosition"
    ],
    "InjectionSelector": [
      "InjectionSelectorPages",
      "InjectionSelectorPageTypes",
      "InjectionSelectorProductData"
    ],
    "Me": [
      "Customer",
      "Employee",
      "Service"
    ],
    "Media": [
      "ImageResource",
      "VideoResource"
    ],
    "MoneyOrPrice": [
      "Money",
      "Price"
    ],
    "ProductSpecificationItem": [
      "ProductSpecificationItemReference",
      "ProductSpecificationItemText",
      "ProductSpecificationItemUnit"
    ],
    "ProductSpecificationItemWithMultiple": [
      "ProductSpecificationItemMultiple",
      "ProductSpecificationItemReference",
      "ProductSpecificationItemText",
      "ProductSpecificationItemUnit"
    ],
    "ProductTactic": [
      "TacticActiveCampaign",
      "TacticAssortmentLadder",
      "TacticBlocks",
      "TacticBuildYourDiscount",
      "TacticBundleInfo",
      "TacticComplementaryProducts",
      "TacticLinkedProductsColor",
      "TacticLinkedProductsSizeAndVariation",
      "TacticOthersBought",
      "TacticOthersBoughtGrid",
      "TacticRecommendedForYou",
      "TacticRelatedProducts",
      "TacticRelativeDiscount",
      "TacticSimilarProducts",
      "TacticUpgradeWith"
    ],
    "Reference": [
      "DynamicVariable",
      "EmailVariable",
      "ExternalLink",
      "ImageAsset",
      "ImageResource",
      "Link",
      "Page",
      "TileResource",
      "VideoResource",
      "Wordbook"
    ],
    "RemoveFromCartPrompt": [
      "RemoveFromCartPromptError"
    ],
    "SetAddressesInCartPrompt": [
      "SetAdressesInCartPromptError"
    ],
    "SetDiscountCodeInCartPrompt": [
      "SetDiscountCodeInCartPromptError",
      "SetDiscountCodeInCartPromptSuccess"
    ],
    "SetQuantityInCartPrompt": [
      "SetQuantityInCartPromptError"
    ],
    "SetShippingMethodInCartPrompt": [
      "SetShippingMethodInCartPromptError"
    ],
    "SetVariantInCartPrompt": [
      "SetVariantInCartPromptError"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AddToCartPrompt": [
      "AddToCartPromptError",
      "AddToCartPromptGiftcard",
      "AddToCartPromptPersonalization",
      "AddToCartPromptSelectVariant",
      "AddToCartPromptSuccess"
    ],
    "AddToCartPromptSuccessTactic": [
      "TacticAddAndSave",
      "TacticBuildYourDiscount",
      "TacticMatchingVariant",
      "TacticRelativeDiscount"
    ],
    "AnchorInjectionType": [
      "InjectionTypeAnchor",
      "InjectionTypeGrid"
    ],
    "Attribute": [
      "BaseAttribute",
      "MoneyAttribute",
      "ProductAttribute",
      "ProductsWithQuantityAttribute"
    ],
    "BlockType": [
      "Block",
      "AccordionListBlock",
      "ActiveCampaignBlock",
      "GalleryBlock",
      "InfoPanelBlock",
      "PageGridBlock",
      "PageSliderBlock",
      "ProductGridSelectorBlock",
      "ProductListBlock",
      "ProductSliderBlock",
      "USPBlock"
    ],
    "BlockTypeWithGlobal": [
      "Block",
      "AccordionListBlock",
      "ActiveCampaignBlock",
      "GalleryBlock",
      "GlobalBlock",
      "InfoPanelBlock",
      "PageGridBlock",
      "PageSliderBlock",
      "ProductGridSelectorBlock",
      "ProductListBlock",
      "ProductSliderBlock",
      "USPBlock"
    ],
    "CartLineItemType": [
      "CartLineItemTypeBundle",
      "CartLineItemTypeFreeProduct",
      "CartLineItemTypeGeneric",
      "CartLineItemTypeGiftcard",
      "CartLineItemTypeUpsellBundle",
      "CartLineItemTypeUpsellGeneric",
      "CartLineItemTypeUpsellPersonalization"
    ],
    "CartMilestoneStepOption": [
      "CartMilestoneStepOptionDiscountCode",
      "CartMilestoneStepOptionProducts"
    ],
    "Element": [
      "ElementButton",
      "ElementChip",
      "ElementLabel",
      "ElementTypography",
      "ElementTypographyRTE"
    ],
    "Field": [
      "ProductField",
      "JSONField",
      "LinkField",
      "MultipleLinkField",
      "ReferenceField",
      "RTEField",
      "ObjectField",
      "NavigationField"
    ],
    "FinalizeCartPrompt": [
      "FinalizeCartPromptError"
    ],
    "GuidedFilter": [
      "GuidedFilterAttributeEnum",
      "GuidedFilterLinkResource"
    ],
    "IAttribute": [
      "BaseAttribute",
      "MoneyAttribute",
      "ProductAttribute",
      "ProductsWithQuantityAttribute"
    ],
    "IBlock": [
      "AccordionListBlock",
      "ActiveCampaignBlock",
      "Block",
      "GalleryBlock",
      "GlobalBlock",
      "InfoPanelBlock",
      "PageGridBlock",
      "PageSliderBlock",
      "ProductGridSelectorBlock",
      "ProductListBlock",
      "ProductSliderBlock",
      "USPBlock"
    ],
    "IField": [
      "JSONField",
      "LinkField",
      "MultipleLinkField",
      "NavigationField",
      "ObjectField",
      "ProductField",
      "RTEField",
      "ReferenceField"
    ],
    "IGuidedFilter": [
      "GuidedFilterAttributeEnum",
      "GuidedFilterLinkResource"
    ],
    "IGuidedFilterItem": [
      "GuidedFilterAttributeEnumItem",
      "GuidedFilterLinkResourceItem"
    ],
    "IWithAssets": [
      "LineItem",
      "Product"
    ],
    "IWithBlocks": [
      "BlockInjection",
      "CommunicationTemplate",
      "CommunicationTemplateLayoutFooter",
      "CommunicationTemplateLayoutHeader",
      "Email",
      "EmailLayoutFooter",
      "EmailLayoutHeader",
      "InjectionPlacementBlocks",
      "InjectionTypeAnchor",
      "InjectionTypeBlockData",
      "InjectionTypeGrid",
      "NavigationItem",
      "Page",
      "TacticBlocks"
    ],
    "IWithBrand": [
      "Page",
      "Product"
    ],
    "IWithCartLineItemLink": [
      "CartLineItemTypeBundle",
      "CartLineItemTypeFreeProduct",
      "CartLineItemTypeGeneric",
      "CartLineItemTypeGiftcard",
      "CartLineItemTypeUpsellBundle",
      "CartLineItemTypeUpsellGeneric",
      "CartLineItemTypeUpsellPersonalization"
    ],
    "IWithCategories": [
      "Product"
    ],
    "IWithElements": [
      "TileResource"
    ],
    "IWithFields": [
      "AccordionItem",
      "AccordionListBlock",
      "Bar",
      "Block",
      "CommunicationTemplate",
      "Email",
      "GalleryBlock",
      "GalleryBlockSlide",
      "GlobalBlock",
      "ImageResource",
      "Page",
      "ProductGridSelectorBlock",
      "ProductListBlock"
    ],
    "IWithFilter": [
      "ProductListBlock",
      "ProductSliderBlock"
    ],
    "IWithImages": [
      "GalleryBlockSlide"
    ],
    "IWithIndex": [
      "AddToCartPromptError",
      "AddToCartPromptGiftcard",
      "AddToCartPromptPersonalization",
      "AddToCartPromptSelectVariant",
      "RemoveFromCartPromptError",
      "SetQuantityInCartPromptError",
      "SetVariantInCartPromptError"
    ],
    "IWithMoney": [
      "Money",
      "Price",
      "PriceDiscount"
    ],
    "IWithProduct": [
      "AddToCartPromptPersonalization",
      "AddToCartPromptSelectVariant",
      "CartLineItem",
      "LineItem",
      "OrderReviewProductReview",
      "ProductField",
      "ProductWithQuantity",
      "ReturnOptionLineItem",
      "TacticGenericOffer",
      "TacticMatchingVariant",
      "TacticUpgradeWithItem",
      "Upsell"
    ],
    "IWithProducts": [
      "AddToCartPromptPersonalization",
      "AddToCartPromptSelectVariant",
      "CartMilestoneStepOptionProducts",
      "ComplementaryRecommendations",
      "HouseBrand",
      "LinkedProduct",
      "ProductAttribute",
      "Recommendation",
      "Recommendations",
      "TacticBuildYourDiscount",
      "TacticComplementaryProducts",
      "TacticLinkedProductsGroup",
      "TacticRelatedProducts",
      "TacticRelativeDiscount",
      "TacticSimilarProducts",
      "UserRecommendations"
    ],
    "IWithRecommendations": [
      "AddToCartPromptSuccess",
      "Cart",
      "TacticOthersBought",
      "TacticOthersBoughtGrid",
      "TacticRecommendedForYou"
    ],
    "IWithReferences": [
      "CaptionOptions",
      "Link",
      "LinkField",
      "PageGridBlock",
      "PageSliderBlock",
      "ProductListBlock",
      "ProductSliderBlock",
      "ProductSpecificationItemReference",
      "ReferenceField",
      "TileResource"
    ],
    "IWithReferencesWithKey": [
      "RTEField"
    ],
    "Injection": [
      "AnchorInjection",
      "BlockInjection"
    ],
    "InjectionPlacement": [
      "InjectionPlacementBlocks",
      "InjectionPlacementBlockTypes",
      "InjectionPlacementGlobal",
      "InjectionPlacementPosition"
    ],
    "InjectionSelector": [
      "InjectionSelectorPages",
      "InjectionSelectorPageTypes",
      "InjectionSelectorProductData"
    ],
    "Me": [
      "Customer",
      "Employee",
      "Service"
    ],
    "Media": [
      "ImageResource",
      "VideoResource"
    ],
    "MoneyOrPrice": [
      "Money",
      "Price"
    ],
    "ProductSpecificationItem": [
      "ProductSpecificationItemReference",
      "ProductSpecificationItemText",
      "ProductSpecificationItemUnit"
    ],
    "ProductSpecificationItemWithMultiple": [
      "ProductSpecificationItemMultiple",
      "ProductSpecificationItemReference",
      "ProductSpecificationItemText",
      "ProductSpecificationItemUnit"
    ],
    "ProductTactic": [
      "TacticActiveCampaign",
      "TacticAssortmentLadder",
      "TacticBlocks",
      "TacticBuildYourDiscount",
      "TacticBundleInfo",
      "TacticComplementaryProducts",
      "TacticLinkedProductsColor",
      "TacticLinkedProductsSizeAndVariation",
      "TacticOthersBought",
      "TacticOthersBoughtGrid",
      "TacticRecommendedForYou",
      "TacticRelatedProducts",
      "TacticRelativeDiscount",
      "TacticSimilarProducts",
      "TacticUpgradeWith"
    ],
    "Reference": [
      "DynamicVariable",
      "EmailVariable",
      "ExternalLink",
      "ImageAsset",
      "ImageResource",
      "Link",
      "Page",
      "TileResource",
      "VideoResource",
      "Wordbook"
    ],
    "RemoveFromCartPrompt": [
      "RemoveFromCartPromptError"
    ],
    "SetAddressesInCartPrompt": [
      "SetAdressesInCartPromptError"
    ],
    "SetDiscountCodeInCartPrompt": [
      "SetDiscountCodeInCartPromptError",
      "SetDiscountCodeInCartPromptSuccess"
    ],
    "SetQuantityInCartPrompt": [
      "SetQuantityInCartPromptError"
    ],
    "SetShippingMethodInCartPrompt": [
      "SetShippingMethodInCartPromptError"
    ],
    "SetVariantInCartPrompt": [
      "SetVariantInCartPromptError"
    ]
  }
};
      export default result;
    